import { useState, useEffect, useRef } from 'react'
import api from '../services/api'

// Cache global fora do componente
const cachePermissoes = { data: null, carregando: false }

export function usePermissoes() {
  const [permissoes, setPermissoes] = useState(cachePermissoes.data || {})
  const montado = useRef(true)

  useEffect(() => {
    montado.current = true
    const usuario = JSON.parse(localStorage.getItem('pg_usuario') || '{}')

    if (cachePermissoes.data) {
      setPermissoes(cachePermissoes.data)
      return
    }

    if (!localStorage.getItem('pg_token')) return

    if (usuario.perfil === 'admin') {
      const tudo = {
        ver_processos_setor:true, ver_todos_processos:true, abrir_processo:true,
        tramitar_processo:true, concluir_processo:true, ver_usuarios:true,
        criar_usuarios:true, ver_cidadaos:true, aprovar_cidadaos:true,
        secretarias:true, tipos_processo:true, modelos_texto:true,
        auditoria:true, configuracoes:true, atendimento_presencial:true, aprovacoes:true
      }
      cachePermissoes.data = tudo
      if (montado.current) setPermissoes(tudo)
      return
    }

    if (cachePermissoes.carregando) return
    cachePermissoes.carregando = true

    api.get('/perfis/minhas-permissoes')
      .then(r => {
        cachePermissoes.data = r.data
        cachePermissoes.carregando = false
        if (montado.current) setPermissoes(r.data)
      })
      .catch(() => {
        cachePermissoes.carregando = false
        if (montado.current) setPermissoes({})
      })

    return () => { montado.current = false }
  }, [])

  function pode(permissao) {
    const usuario = JSON.parse(localStorage.getItem('pg_usuario') || '{}')
    if (usuario.perfil === 'admin') return true
    return !!(cachePermissoes.data || permissoes)[permissao]
  }

  return { permissoes, pode }
}

export function limparCachePermissoes() {
  cachePermissoes.data = null
  cachePermissoes.carregando = false
}
